import React, { Fragment, useEffect, useRef, memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, useOnScreen } from 'tmt-ui-kit';

import config from '~/config';

const Container = styled.div`
  text-align: center;
  padding: 40px 0;
`;

const LxImageContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 9px;
  object-fit: cover;

  &[src=''] {
    display: none;
  }
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: 768px) {
    width: 36px !important;
    height: 36px !important;
    margin-right: 5px;
  }
`;

const LoadMoreButton = styled.a`
  display: block;
  width: 160px;
  border: 1px solid ${props => props.theme.lightGray1};
  border-radius: 5px;
  margin: 20px auto 0 !important;
  padding: 7px 12px !important;
  cursor: pointer;
  user-select: none;
`;

const ReviewMore = props => {
  const lxContainerRef = useRef(null);
  const lxImageRefs = useRef([]);
  const isSeen = useOnScreen(lxContainerRef);
  useEffect(() => {
    if (isSeen) {
      lxImageRefs.current.forEach((lxImageRef) => {
        const lxImageDom = lxImageRef;
        lxImageDom.src = lxImageDom.dataset.src;
      });
    }
  }, [isSeen]);
  const { lxInfo, onClickLoadMore, showLoadMore, withoutReview = 0 } = props;
  const { name } = lxInfo;
  return (
    <Container>
      {withoutReview > 0 && (
        <Fragment>
          <LxImageContainer ref={lxContainerRef}>
            <Image
              ref={c => {
                lxImageRefs.current[0] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/user-review.png`}
            />
            <Image
              ref={c => {
                lxImageRefs.current[1] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/1.jpg`}
            />
            <Image
              ref={c => {
                lxImageRefs.current[2] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/2.jpg`}
            />
            <Image
              ref={c => {
                lxImageRefs.current[3] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/3.jpg`}
            />
            <Image
              ref={c => {
                lxImageRefs.current[4] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/4.jpg`}
            />
            <Image
              ref={c => {
                lxImageRefs.current[5] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/5.jpg`}
            />
            <Image
              ref={c => {
                lxImageRefs.current[6] = c;
              }}
              data-src={`${config.assetPath}/static/images/Reviews/more.png`}
            />
          </LxImageContainer>
          <Typo.Regular>
            + {withoutReview} more travelers have enjoyed
            <br />
            the local experience with {name.first}
          </Typo.Regular>
        </Fragment>
      )}
      {showLoadMore && <LoadMoreButton onClick={onClickLoadMore}>More Reviews</LoadMoreButton>}
    </Container>
  );
};

ReviewMore.propTypes = {
  lxInfo: PropTypes.object,
  onClickLoadMore: PropTypes.func,
  showLoadMore: PropTypes.bool,
  // withoutReview: PropTypes.number
};

export default memo(
  ReviewMore,
  (prevProps, nextProps) => {
    if (prevProps.lxInfo.name !== nextProps.lxInfo.name) {
      return false;
    }
    if (prevProps.withoutReview !== nextProps.withoutReview) {
      return false;
    }
    if (prevProps.showLoadMore !== nextProps.showLoadMore) {
      return false;
    }
    return true;
  }
);
